import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { extractPathName, isValidURL } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { loginRedirect } from '../utils/loginRedirect';
import { getActiveSessionURL, getAuthCallbackAPI } from '../utils/envVals';
import Loader from '../components/Loader';
import appInsights from '../utils/telemetry';

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const { setUserContext } = useAuth() || {};

    useEffect(() => {
        const handleAuthCallback = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const stateParam = urlParams.get('state');
            const code = urlParams.get('code');
            console.log('State param:', stateParam);
            console.log('Code param:', code);
            if (!stateParam) {
                console.error('State parameter is missing', window.location.href);
                navigate('/error');
                return;
            }
            let decodedState;
            try {
                decodedState = JSON.parse(atob(stateParam));
            } catch (decodeError) {
                console.error('Failed to decode state parameter', decodeError);
                navigate('/error');
                return;
            }
            const returnUrl = typeof decodedState.returnUrl === 'string'
                ? decodedState.returnUrl
                : '/';
            if (!isValidURL(returnUrl) || typeof code !== 'string') {
                console.error('Callback parameters are invalid');
                return;
            }
            try {
                await exchangeCodeForTokens(code, stateParam);
                navigate(extractPathName(returnUrl));
            } catch (error: any) {
                console.error('Error exchanging code for tokens', error);
                if (error?.error?.meta?.loginId) {
                    appInsights?.setAuthenticatedUserContext(error.error.meta.loginId)
                }
                navigate('/auth/denyAllAccess?scope=all');
            }
        };
        handleAuthCallback();
    }, [navigate, setUserContext]);

    return <Loader />;
};

export const exchangeCodeForTokens = async (code: string, state: string): Promise<void> => {
    const callbackAPI = getAuthCallbackAPI();
    const { returnUrl = '/' } = JSON.parse(atob(state));
    const params = new URLSearchParams({
        code,
        redirect_uri: `${window.location.origin}/auth/callback`,
        state: returnUrl,
    });
    const url = `${callbackAPI}?${params}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    // Handle an empty response gracefully.
    const text = await response.text();
    if (!text) {
        return;
    }
    const resp = JSON.parse(text);
    if (resp?.error) {
        console.error('Callback failed', resp.error);
        throw new Error(resp.error);
    }
};

export default AuthCallback;